angular.module('unica_track.track_services')

.factory('TrackDeleteService', function ($http, getBaseApiURL) {

	var trackDeleteService = {};

	trackDeleteService.delete = function (trackId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/track/delete/' + trackId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	trackDeleteService.deleteTrackMaterial = function (trackId, type) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/track/delete-track-material/' + trackId + '/' + type,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.track;
			}

		});
	};

	return trackDeleteService;
});